import { createFileRoute } from "@tanstack/react-router";
import { PublicEventDetailPage } from "@/features/event-explorer/components/PublicEventDetailPage";
import { isSafeInternalPath } from "@/lib/navigation/userProfileNavigation";

// クエリパラメータの型定義
interface EventCodeSearch {
  action?: "join";
  from?: string;
}

export const Route = createFileRoute("/event-search/code/$event-code")({
  component: PublicEventDetailPage,
  validateSearch: (search: Record<string, unknown>): EventCodeSearch => {
    return {
      action: search.action === "join" ? "join" : undefined,
      from: isSafeInternalPath(search.from) ? search.from : undefined,
    };
  },
  loader: ({ params }) => {
    return { eventCode: params["event-code"] };
  },
});
